import { APP_INITIALIZER, ApplicationConfig, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RECAPTCHA_LOADER_OPTIONS } from 'ng-recaptcha';
import { APP_CONFIG, AppConfig } from '../configuration';
import { SupportedLocale } from '../consts/locale';
import { NgxCookiebotConfig, NgxCookiebotService } from '@halloverden/ngx-cookiebot';
import { CookiebotConfig } from '../configuration/cookiebot.config';
import { ServerErrorInterceptor } from '@portal-front/util-http-layer';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useFactory: (locale: string) => ({
        onBeforeLoad(url: URL) {
          url.searchParams.set('hl', locale);

          return { url };
        },
      }),
      deps: [LOCALE_ID],
    },
    {
      provide: 'googleTagManagerId',
      useFactory: (config: AppConfig, locale: SupportedLocale) => config.gtm[locale],
      deps: [APP_CONFIG, LOCALE_ID],
    },
    {
      provide: NgxCookiebotConfig,
      useFactory: (config: AppConfig, locale: SupportedLocale) => {
        return new CookiebotConfig(config.cookiebot.id, locale);
      },
      deps: [APP_CONFIG, LOCALE_ID],
    },
    {
      provide: NgxCookiebotService,
      useClass: NgxCookiebotService,
      deps: [NgxCookiebotConfig, PLATFORM_ID],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (cookiebotService: NgxCookiebotService): (() => Promise<void>) => {
        return (): Promise<void> => {
          return cookiebotService.init();
        };
      },
      deps: [NgxCookiebotService, PLATFORM_ID],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ServerErrorInterceptor, multi: true },
  ],
};
